import React, { memo } from 'react';

import GlobalStyleWrapper from './style';

const GlobalStyle = memo(({ children }) => (
    <GlobalStyleWrapper>{children}</GlobalStyleWrapper>
));

export default GlobalStyle;